class HamburgerMenu extends HTMLElement {
    constructor() {
      super();
      this.menuContainer = this.querySelector('nav.header__inline-menu');
      this.menuItems = this.menuContainer?.firstElementChild.children;
      this.hamburgerIcon = this.querySelector('li.hamburger-menu');
      this.dropdown = this.querySelector('.dropdown-more');
      this.listShowing = [];
      this.listHidden = [];
      this.open = false;
    }
  
    init() {
      setTimeout(() => {
        this.checkMenuLines();
        this.events();
      }, 400);
    }
  
    events() {
      this.hamburgerIcon?.addEventListener('click', () => {
        this.open = !this.open;
        this.classList.toggle('open', this.open);
      });
  
      window.addEventListener('resize', () => {
        this.checkMenuLines();
      });
    }
  
    checkMenuLines() {
      if (!this.menuContainer || !this.menuItems) return;
  
      const menuWidth = this.menuContainer.offsetWidth;
      let menuItemsWidth = 0;
      
      Array.from(this.menuItems).forEach(item => {
        if (item !== this.hamburgerIcon) {
          menuItemsWidth += item.offsetWidth;
          item.dataset.show = menuItemsWidth <= menuWidth ? 'true' : 'false';
          item.dataset.sumWidth = menuItemsWidth;
          menuItemsWidth <= menuWidth && this.listShowing.push(item);
          menuItemsWidth >= menuWidth && this.listHidden.push(item);
        }
      });

  
      if (menuItemsWidth > menuWidth) {
        this.hamburgerIcon?.classList.add('visible');

        //See if the menu icon can fit in the menu container
        let hamburgerWidth = this.hamburgerIcon.offsetWidth;
        for(let i = this.listShowing.length; i > 0; i--){
          const lisSum = parseInt(this.listShowing[i - 1].dataset.sumWidth) + parseInt(hamburgerWidth) + 1;
            if(lisSum > menuWidth){
                //set last item to false
                this.listShowing[i -1].dataset.show = 'false';
                this.listHidden.push(this.listShowing[i -1]);
            }
        }
        this.listHidden.forEach(item => {
          this.dropdown.appendChild(item);
        });
      } else {
        this.hamburgerIcon?.classList.remove('visible');
      }

      //Show menu
      hamburgerMenuEl.classList.add('visible');

    }
  }
  
  customElements.define('hamburger-menu-see-more', HamburgerMenu);
  
  // Initialize
  const hamburgerMenuEl = document.querySelector('hamburger-menu-see-more');
  if (hamburgerMenuEl) {
    hamburgerMenuEl.init();
  }